export default "__VITE_ASSET__CTVuQCU1__"